import React, { FC, MouseEventHandler, useRef, useCallback } from 'react';
import { useDidMount } from '@surveycake/rhooks';
import { useOnKeyDownEnter } from '@surveycake/rhooks';
import { SinglelineTextField } from '../../TextField';

export interface ElseTextFieldProps {
  initialValue: string;
  onChange: (value: string) => void;
  onFinished?: (value: string) => void;
}

const ElseTextField: FC<ElseTextFieldProps> = ({
  onChange,
  initialValue,
  onFinished
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const onBlur = useCallback(() => {
    if (inputRef.current) {
      const { value } = inputRef.current;
      onChange(value);
    }
  }, [onChange]);
  const onClick = useCallback<MouseEventHandler>(event => {
    /**
     * prevent from inactivating the option.
     */
    event.stopPropagation();
  }, []);
  const onKeyDown = useOnKeyDownEnter<HTMLInputElement>(
    useCallback(
      event => {
        event.preventDefault();

        if (onFinished && inputRef.current) {
          const { value } = inputRef.current;
          onFinished(value);
        }
      },
      [onFinished]
    )
  );

  useDidMount(() => {
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.value = initialValue;
    }
  });

  return (
    <SinglelineTextField
      ref={inputRef}
      type="text"
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onClick={onClick}
    />
  );
};

export default ElseTextField;
